if (typeof HSFProductBundler !== "function") {
  class HSFProductBundler extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector("css-slider")) {
        this.querySelector("css-slider").addEventListener("ready", () => {
          this.init();
        });
      } else {
        this.init();
      }
    }

    init() {
      this._purchaseTrackingPaymentFrequency = this.#mapHsfPaymentFrequency(
        this.querySelector('#data-payment-type-container input[type=radio]:checked')?.value
      );

      $("#data-payment-type-container input[type=radio]").each((idx, el) => {
        el.addEventListener("change", (event) => {
          if (!this.findEmptySlot() && this.hasValidHSFChildAndAdultProduct() && this.hasPaymentTypeSelected()) {
            this.classList.add("bundler-full");
            $('#bundle_submit_button').removeClass('disabled');
          }

          const parentSlot = this.querySelector('[data-js-bundler-product][data-adult-product="true"]');
          if (!parentSlot?.dataset?.productId) return;

          const productId = parentSlot.dataset.productId;

          const product = this.querySelector('#parentSectionProducts').querySelector(`#product-item-${productId}`);
          if (!product) return;

          const id = el.dataset.targetVariant;

          const variant = product
            .querySelector("product-variants")
            .getVariantData()
            .find((v) => {
              return v["id"] == id;
            });          
          if (!variant) return;
            
          const variantInfo = this.getVariantInfoData(product);
          const {variant: selectedVariant } = this.changeVariantPerPaymentType(variant, product);

          this.updateSlotDataset(parentSlot, selectedVariant, variantInfo, product)
          el.dataset.targetVariant = variant.id;
          this.updateProductDisplayPrice(event.target.value)
          if (event.isTrusted) {
            this.#trackPurchaseOptionSelected(event);
          } else {
            this._purchaseTrackingPaymentFrequency = this.#mapHsfPaymentFrequency(event.target.value);
          }
        });
      });

      this.bundleProducts = [
        ...this.querySelectorAll("[data-js-bundler-product]"),
      ];
      this._bundleTemplate = this.querySelector(
        "[data-js-bundler-product]"
      ).cloneNode(true);
      this._bundleMin = parseInt(this.dataset.minimum);

      this.querySelectorAll("[data-js-product-add-to-cart]").forEach((elm) => {
        elm.addEventListener("click", (e) => {
          // Slider navigation lives inside the clickable card area; ignore those controls.
          if (
            e.target.closest(".css-slider-button") ||
            e.target.closest(".css-slider-pagination") ||
            e.target.closest(".css-slider-dot")
          ) {
            return;
          }

          e.preventDefault();
          const product = e.target.closest("[data-js-product-item]");
          if (!product) return;
          const id = product
            .querySelector(".product-form")
            .querySelector('input[name="variantId"]').value;
          const variant = product
            .querySelector("product-variants")
            .getVariantData()
            .find((variant) => {
              return variant["id"] == id;
            });
          this.addToBundle(variant, product);
          this.classList.add("opened");
        });
      });

      this.querySelectorAll("[data-js-bundler-product-remove]").forEach(
        (elm) => {
          elm.addEventListener("click", (e) => {
            const target = e.target;

            const slot = target.closest('.bundler-product[data-js-bundler-product]');
            if(!slot) return;
            const isParentProduct = slot.dataset.adultProduct;
            const isChildProduct = slot.dataset.childProduct;

            if(isParentProduct) {

              // reset price to per month on clearing
              const perMonthRadioInput = this.querySelector('#payment-type-per-month');
              perMonthRadioInput.checked = true;
              perMonthRadioInput.dispatchEvent(new Event('change'));
              $('#hsf-purchase-type-container').addClass('display-none');
              $('#payment-type-per-month,#payment-type-per-shipment').attr('data-target-variant', '')
            }
            this.clearSlot(target.closest("[data-js-bundler-product]"));
            
          });
        }
      );

      if (this.querySelector("[data-js-bundler-toggle]")) {
        this.querySelector("[data-js-bundler-toggle]").addEventListener(
          "click",
          (e) => {
            if (window.innerWidth < 768) {
              this.classList.toggle("opened");
            }
          }
        );
      }

      this.querySelector("[data-js-add-bundle-to-cart]").addEventListener(
        "click",
        async (e) => {
          const subscriptionPaymentList = window.cartAvailablePaymentMethods?.subscription || [];
          const onlineIndex = subscriptionPaymentList.findIndex((method) => method === "Online");
          const fallbackPaymentMethod =
            onlineIndex !== -1
              ? subscriptionPaymentList[onlineIndex]
              : subscriptionPaymentList[0];
          const selectedPaymentMethod = window.cartDataForPaymentSelectionInCart?.attributes?._paymentMethod
            || fallbackPaymentMethod;
          const isManualPayment = KROWN.settings.manualPaymentTypes.includes(selectedPaymentMethod);
          if (!this.findEmptySlot()) {
            let items = [];
            let adultProductIds = '';
            let childProductIds = '';
            let installmentObj = {};
            this.bundleProducts.map((elm) => {
              if (elm.dataset.sku.split("_")[0] == "inst") {
                const installmentFeeVariantId = localStorage.getItem(
                  "installmentFeeVariantId"
                );
                const installmentFeeVariantSellingPlanId = localStorage.getItem(
                  "installmentFeeVariantSellingPlanId"
                );
                const cartItems = JSON.parse(
                  document
                    .querySelector("#cartItemsInfo")
                    .textContent.replace("\n", "")
                );
                let hasInstallmentFee = false;

                cartItems.forEach((item) => {
                  if (item.id == installmentFeeVariantId) {
                    hasInstallmentFee = true;
                  }
                });
                if (!hasInstallmentFee && installmentFeeVariantId && installmentFeeVariantSellingPlanId) {
                  let instProps = {
                    _hsf: true,
                    _sellingplan: isManualPayment ? installmentFeeVariantSellingPlanId : ''
                  };
                  if (typeof window.mergeCartLinePropertiesWithGlobalId === "function") {
                    instProps = window.mergeCartLinePropertiesWithGlobalId(
                      installmentFeeVariantId,
                      instProps
                    );
                  }
                  installmentObj = {
                    id: installmentFeeVariantId,
                    quantity: 1,
                    selling_plan: isManualPayment ? '' : installmentFeeVariantSellingPlanId,
                    properties: instProps,
                  };
                }
              }
              if (elm.dataset.adultProduct) {
                adultProductIds = adultProductIds ? adultProductIds + ',' + elm.dataset.id : elm.dataset.id;
              } else if(elm.dataset.childProduct) {
                childProductIds = childProductIds ? childProductIds + ',' + elm.dataset.id : elm.dataset.id;
              }
            });
            this.bundleProducts.map((elm) => {
              if (elm.dataset.id) {
                if (
                  !items.find((item) => {
                    if (item.id == elm.dataset.id) {
                      item.quantity++;
                      return true;
                    }
                  })
                ) {
                  let itemObj = {
                    id: elm.dataset.id,
                    quantity: 1,
                    selling_plan: isManualPayment ? '' : elm.dataset.sellingPlan
                  };
                  if (elm.dataset.childProduct) {
                    itemObj.properties = { _hsf: true, _adultProductIds: adultProductIds };
                  } else {
                    itemObj.properties = { _hsf: true, _childProductIds: childProductIds };
                  }

                  if(elm.dataset.sku.split("_")[0] === "inst"){
                    itemObj.properties._subscriptionType = "installment";
                  } else {
                    itemObj.properties._subscriptionType = "normal";
                  }

                  if (isManualPayment) {
                    itemObj.properties._sellingplan = elm.dataset.sellingPlan;
                  }
                  itemObj.properties._discountvalue = elm.dataset.discountValue;
                  if (elm.dataset.totalMonthlyValue && elm.dataset.sku.split("_")[0] === "inst") {
                    const monthlyRaw = String(elm.dataset.totalMonthlyValue).trim();
                    const monthlyNum = Number(monthlyRaw);
                    itemObj.properties._monthly_base_total =
                      monthlyRaw !== '' && !Number.isNaN(monthlyNum)
                        ? monthlyNum.toFixed(2)
                        : monthlyRaw;
                  }
                  if (typeof window.mergeCartLinePropertiesWithGlobalId === "function") {
                    itemObj.properties = window.mergeCartLinePropertiesWithGlobalId(
                      itemObj.id,
                      itemObj.properties
                    );
                  }
                  items.push(itemObj);
                }
              }
            });
            const countriesThatApplyFeeForHSF = ["US", "CA", "MX", "AU", "NZ"];
            const shouldApplyFeeForHSF = countriesThatApplyFeeForHSF.includes(Shopify.country);
            if (Object.keys(installmentObj).length != 0 && shouldApplyFeeForHSF) {
              items.push(installmentObj);
            }

            // Add handling fee logic
            const handlingFeeObj = this.getHandlingFeeItem( adultProductIds, childProductIds );
            if (handlingFeeObj) {
              items.push(handlingFeeObj);
              console.log('Handling fee added to cart items:', handlingFeeObj);
            }

            if (items.length > 0) {
              const submitButton = this.querySelector(
                "[data-js-add-bundle-to-cart]"
              );
              submitButton.classList.add("working");
              const hsfFormObj = typeof getHSFFormCookie === 'function' ? getHSFFormCookie() : null;
              const hsfChildDetails = hsfFormObj ? JSON.stringify(hsfFormObj) : null;

              window.handleAddToCart(
                JSON.stringify({
                  attributes: { "_paymentMethod": selectedPaymentMethod, "hsfChildDetails": hsfChildDetails },
                  items: items
                }),
                items.reduce((total, { quantity }) => total + quantity, 0),
                { "Content-Type": "application/json" },
                async () => {
                  submitButton.classList.remove("working");
                  this.querySelectorAll("[data-js-bundler-product]").forEach(
                    (elm) => {
                      this.clearSlot(elm);
                    }
                  );

                  $('#hsf-purchase-type-container input[type=radio]').prop('checked', false);
                  $('#hsf-purchase-type-container').addClass('display-none');
                  this.classList.remove("opened");

                  // Add refreshCartPaymentMethods call
                  if (typeof window.refreshCartPaymentMethods === 'function') {
                      await window.refreshCartPaymentMethods();
                  }
                }
              );
            }
            const defaultPaymentType = KROWN.settings.product_default_paymentType;
            let paymentType = 'per_month';
            if(defaultPaymentType == 'PayInFull') {
              paymentType = 'per_shipment';
            }
            this.updateProductDisplayPrice(paymentType);
          }
        }
      );

      // Initialize product display prices after the page finishes loading all JS/components
      const initDisplayAfterLoad = () => {
        try {
          const defaultPaymentType = KROWN.settings.product_default_paymentType;
          let paymentType = 'per_month';
          if (defaultPaymentType === 'PayInFull') {
            paymentType = 'per_shipment';
          }
          this.updateProductDisplayPrice(paymentType);
        } catch (e) {
          console.warn('HSFProductBundler: Failed to initialize display price on load', e);
        }
      };

      if (document.readyState === 'complete') {
        initDisplayAfterLoad();
      } else {
        window.addEventListener('load', initDisplayAfterLoad, { once: true });
      }

    }

    findEmptySlot() {
      return this.bundleProducts.find((elm) => {
        return elm.classList.contains("bundler-product--empty");
      });
    }

    hasValidHSFChildAndAdultProduct() {
      let adultItemCount = 0;
      let childItemCount = 0;
      this.bundleProducts.map((elm) => {
        if (elm.dataset.adultProduct) {
          adultItemCount++;
        } else if(elm.dataset.childProduct) {
          childItemCount++;
        }
      });
      if (adultItemCount > 0 && childItemCount > 0) {
        return true;
      }
      return false;
    }

    clearSlot(slot) {
      if (this.bundleProducts.length > this._bundleMin) {
        this.bundleProducts.splice(this.bundleProducts.indexOf(slot), 1);
        slot.remove();
      } else {
        slot.product.classList.remove("product-item--bundled");
        if (slot.product.offsetParent) {
          slot.product.offsetParent.classList.remove("parent-product-item--bundled");
        } else {
          document.querySelector('#childSectionProducts').classList.remove("parent-product-item--bundled");
        }
        let emptyBlock = '';
        if (slot.dataset.adultProduct) {
          emptyBlock = `<span class="bundler-product__placeholder"><strong>${
            window.hsfBundlerTranslations?.adultLabel || "Adult"
          }:</strong><br>${
            window.hsfBundlerTranslations?.adultMessage ||
            "Please add an adult product"
          }</span>`;
          $('#childSectionProducts').addClass('blurry');
          $('#childSectionHeading').addClass('blurry');
          this.querySelector('.hsf-bundler__handling-fee').classList.add('hidden');
          this.querySelector('#hsf-bundle-price').classList.add('hidden');
        }else{
          emptyBlock = `<span class="bundler-product__placeholder"><strong>${
            window.hsfBundlerTranslations?.childLabel || "Child"
          }:</strong><br>${
            window.hsfBundlerTranslations?.childMessage ||
            "Please add a child product"
          }</span>`;
        }
        slot.dataset.id = "";
        slot.dataset.productId = "";
        slot.dataset.sellingPlan = "";
        slot.dataset.adultProduct = "";
        slot.dataset.childProduct = "";
        slot.product = null;
        slot.classList.add("bundler-product--empty");
        slot.querySelector("[data-js-bundler-product-text]").innerHTML = emptyBlock;

        slot.querySelector("[data-js-bundler-product-image]").innerHTML = "";
      }
      if ( this.findEmptySlot() || !this.hasValidHSFChildAndAdultProduct() || !this.hasPaymentTypeSelected()) {
        this.classList.remove("bundler-full");
        $('#bundle_submit_button').addClass('disabled');
      }
    }

    hasPaymentTypeSelected() {
      const selectedPaymentTypeContainer = this.querySelector("#data-payment-type-container");
      const selectedPaymentType = selectedPaymentTypeContainer.querySelector("input[type=radio]:checked")?.value;
      return !!selectedPaymentType;
    }


    createSlot() {
      const newSlot = this._bundleTemplate.cloneNode(true);
      newSlot
        .querySelector("[data-js-bundler-product-remove]")
        .addEventListener("click", (e) => {
          this.clearSlot(e.target.closest("[data-js-bundler-product]"));
        });
      this.querySelector("[data-js-bundler-products]").appendChild(newSlot);
      this.bundleProducts.push(newSlot);
    }

    addToBundle(variant, product) {
      let slot = this.findEmptySlot();
      const imageSrc = variant.featured_image
          ? variant.featured_image.src
          : product.querySelector("[data-js-quick-buy-product-image]")
              ?.textContent?.trim();

      if (!slot && this.hasAttribute("data-limit-maximum")) {
        this.createSlot();
        slot = this.findEmptySlot();
      }

      if (slot) {
        let productTitle = '';
        if (product.offsetParent.id == 'parentSectionProducts') {
          slot.dataset.adultProduct = 'true';
          const defaultPaymentType = KROWN.settings.product_default_paymentType
          if(defaultPaymentType == 'PayInFull') {
            $('#payment-type-per-shipment').prop('checked', true);
            this._purchaseTrackingPaymentFrequency = 'pay_in_full';
          } else if(defaultPaymentType == 'PayInInstallments') {
            $('#payment-type-per-month').prop('checked', true);
            this._purchaseTrackingPaymentFrequency = 'inst';
          }
          productTitle = window.hsfBundlerTranslations?.adultLabel || "Adult";
        }

        if (product.offsetParent.id == 'childSectionProducts') {
          slot.dataset.childProduct = 'true';
          productTitle = window.hsfBundlerTranslations?.childLabel || "Child";
        }

        slot.classList.remove("bundler-product--empty");
        slot.querySelector("[data-js-bundler-product-text]").innerHTML = `
          <span class="bundler-product__text-title text-line-height--medium text-weight--bold">${
            productTitle
          }</span>
          ${
            product
              .querySelector("product-variants")
              .hasAttribute("data-has-variants")
              ? `<span class="bundler-product__text-variant text-color--opacity">${
            product.querySelector("[data-js-quick-buy-product-title]")
              .textContent
          }</span>`
              : ""
          }
        `;
        slot.querySelector("[data-js-bundler-product-image]").innerHTML = `
          <img src="${this.getResizedImageSrc(imageSrc, 60)}"
            srcset="
              ${this.getResizedImageSrc(imageSrc, 60)} 60w,
              ${this.getResizedImageSrc(imageSrc, 120)} 120w,
              ${this.getResizedImageSrc(imageSrc, 180)} 180w
            "
            sizes="60px"
            onerror="this.style.display='none'"
          />
        `;

        if (this.hasAttribute("data-limit-bundles")) {
          product.classList.add("product-item--bundled");
          product.offsetParent.classList.add("parent-product-item--bundled");
        }


        const productId = product.id.slice('product-item-'.length, product.id.length);
        slot.dataset.productId = productId;
        const { variant: selectedVariant } = this.changeVariantPerPaymentType(variant, product);
        const variantInfo = this.getVariantInfoData(product);

        this.updateSlotDataset(slot, selectedVariant, variantInfo, product);

        const isParentProduct = product.offsetParent.id == "parentSectionProducts";
        if(isParentProduct) {
          $('#hsf-purchase-type-container').removeClass('display-none');
          // Remove class blurry from child container
          $('#childSectionProducts').removeClass('blurry');
          $('#childSectionHeading').removeClass('blurry');
        }

      } else {
        // when bundle is full, show message
      }

      if ( !this.findEmptySlot() && this.hasValidHSFChildAndAdultProduct() && this.hasPaymentTypeSelected()) {
        this.classList.add("bundler-full");
        $('#bundle_submit_button').removeClass('disabled');
      }

    }

    getVariantInfoData(product) {
      return  JSON.parse(
        product.querySelector("#variantInfo").textContent.replace("\n", "")
      );
    }

    #mapHsfPaymentFrequency(value) {
      if (value === 'per_month') return 'inst';
      if (value === 'per_shipment') return 'pay_in_full';
      return '';
    }

    #mapHsfSubscriptionFrequency(value) {
      if (value === 'per_month') return '1 month';
      if (value === 'per_shipment') return '4 months';
      return '';
    }

    #getBundleSlotProductName(slot) {
      return slot?.product
        ?.querySelector('[data-js-quick-buy-product-title]')
        ?.textContent
        ?.trim() || '';
    }

    #getBundleSlotTrackingData(role) {
      const attr = role === 'adult' ? 'data-adult-product' : 'data-child-product';
      const slot = this.querySelector(`[data-js-bundler-product][${attr}="true"]`);
      if (!slot) {
        return { product_id: '', variant_id: '', product_name: '' };
      }

      return {
        product_id: slot.dataset.productId || '',
        variant_id: slot.dataset.id || '',
        product_name: this.#getBundleSlotProductName(slot)
      };
    }

    #trackPurchaseOptionSelected(event) {
      if (!event?.isTrusted) return;

      const selectedValue = event.target?.value;
      const selectedPaymentFrequency = this.#mapHsfPaymentFrequency(selectedValue);
      if (!selectedPaymentFrequency) return;
      if (selectedPaymentFrequency === this._purchaseTrackingPaymentFrequency) return;

      const adult = this.#getBundleSlotTrackingData('adult');
      const child = this.#getBundleSlotTrackingData('child');
      const eventData = {
        event: 'purchase_option_selected',
        page_type: 'healthy_starts',
        selected_purchase_type: 'subscription',
        previous_purchase_type: 'subscription',
        selected_payment_frequency: selectedPaymentFrequency,
        previous_payment_frequency: this._purchaseTrackingPaymentFrequency || '',
        subscription_frequency: this.#mapHsfSubscriptionFrequency(selectedValue),
        adult_product_id: adult.product_id,
        adult_variant_id: adult.variant_id,
        adult_product_name: adult.product_name,
        child_product_id: child.product_id,
        child_variant_id: child.variant_id,
        child_product_name: child.product_name
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);

      const css1 = 'background: red; color: #fff; font-size: normal; border-radius: 3px 0 0 3px; padding: 3px 4px;';
      const css2 = 'background-color: blue; color: #fff; font-size: normal; border-radius: 0 3px 3px 0; padding: 3px 4px;';
      console.log('%cGTM DataLayer Event:%cpurchase_option_selected', css1, css2, eventData);

      this._purchaseTrackingPaymentFrequency = selectedPaymentFrequency;
    }

    updateSlotDataset(slot, variant, variantInfo, product) {
      for (let data of variantInfo) {
        if (data.id == variant.id) {
          slot.dataset.discountValue = data.discountValue;
          break;
        }
      }

      slot.product = product;
      slot.dataset.id = product.querySelector('input[name="variantId"]').value;
      product.querySelectorAll('div[data-subscription]').forEach(elm => {
        if (elm.getAttribute('value') === slot.dataset.id) {
          slot.dataset.sellingPlan = elm.dataset.subscription;
          slot.dataset.totalMonthlyValue = elm.dataset.totalMonthlyVal;
        }
      });

      slot.dataset.sku = variant.sku;
      const variantTitleEl = slot.querySelector('.bundler-product__text-variant');
      if(!variantTitleEl) {
        variantTitleEl.innerText = variant.title;
      }
    }

    changeVariantPerPaymentType(variant, product) {
      const isParentProduct = product.offsetParent.id == "parentSectionProducts";
      const sku = variant.sku;
      const isPerShipmentSku = !sku.startsWith('inst_')
      const isInstallmentSku = !isPerShipmentSku
      const productVariantDetails = product.querySelector("product-variants").getVariantData();
      const perShipmentSku = isPerShipmentSku ? sku : sku.slice('inst_'.length, sku.length)
      const perMonthSku = isInstallmentSku ? sku :  "inst_" + sku ;
      const perMonthVariant = productVariantDetails.find((v) => v.sku === perMonthSku);
      const perShipmentVariant = productVariantDetails.find((v) => v.sku === perShipmentSku);

      if (isParentProduct) {
        const selectedPaymentTypeContainer = this.querySelector("#data-payment-type-container");
        const selectedPaymentType = selectedPaymentTypeContainer.querySelector("input[type=radio]:checked")?.value;

        if (selectedPaymentType == "per_month") {
          variant = perMonthVariant;
        } else if(selectedPaymentType == "per_shipment") {
          variant = perShipmentVariant;
        }

        product.querySelector('input[name="variantId"]').value = variant.id;
        product.querySelector('input[name="id"]').value = variant.id;

        const perShipmentElRow = this.querySelector('[data-js-bundle-payment-type-per-shipment]');
        const perMonthElRow = this.querySelector('[data-js-bundle-payment-type-per-month]');
        const perShipmentEl = this.querySelector("#bundle-payment-amount-per-shipment");
        const perMonthEl = this.querySelector("#bundle-payment-amount-per-month");
        const bundlePriceEl = this.querySelector('#hsf-bundle-price');
        const perShipmentPrice = this.getTaxedPrice(product, perShipmentVariant);
        const perMonthPrice = this.getTaxedPrice(product, perMonthVariant);

        if(perShipmentVariant){
          perShipmentElRow.querySelector('#payment-type-per-shipment').dataset.targetVariant = perShipmentVariant?.id ?? ''
          perShipmentElRow.classList.remove('display-none')
          this.querySelector('.bundle-payment-type__separator').classList.remove('display-none');

          perShipmentEl.innerHTML = perShipmentPrice;
        } else {
          perShipmentElRow.classList.add('display-none')
          this.querySelector('.bundle-payment-type__separator').classList.add('display-none');
        }

        if(perMonthVariant) {
          perMonthElRow.querySelector('#payment-type-per-month').dataset.targetVariant = perMonthVariant?.id ?? ''
          perMonthElRow.classList.remove('display-none')
          this.querySelector('.bundle-payment-type__separator').classList.remove('display-none');
          perMonthEl.innerHTML = perMonthPrice;
        } else {
          perMonthElRow.classList.add('display-none')
          this.querySelector('.bundle-payment-type__separator').classList.add('display-none');
        }
        // Based on selected payment type, update the bundle price
        if(selectedPaymentType == "per_month") {
          const perMonthText = window.hsfBundlerTranslations?.perMonth || 'per month';
          bundlePriceEl.innerHTML = '<span>' + perMonthPrice + '</span> ' + perMonthText;
          if(document.getElementById('monthly_handling_fee').value) {
            document.getElementById('hsf-handling-fee').textContent = document.getElementById('monthly_handling_fee').value + ' ';
            document.getElementById('hsf-handling-fee-text-shipment').classList.add('hidden');
            document.getElementById('hsf-handling-fee-text-month').classList.remove('hidden');
            this.querySelector('.hsf-bundler__handling-fee').classList.remove('hidden');
          }
        } else if(selectedPaymentType == "per_shipment") {
          const perShipmentText = window.hsfBundlerTranslations?.perShipment || 'per shipment';
          bundlePriceEl.innerHTML = '<span>' + perShipmentPrice + '</span> ' + perShipmentText;
          if(document.getElementById('shipment_handling_fee').value) {
            document.getElementById('hsf-handling-fee').textContent = document.getElementById('shipment_handling_fee').value + ' ';
            document.getElementById('hsf-handling-fee-text-month').classList.add('hidden');
            document.getElementById('hsf-handling-fee-text-shipment').classList.remove('hidden');
            this.querySelector('.hsf-bundler__handling-fee').classList.remove('hidden');
          }
        }

        if(document.getElementById('monthly_handling_fee').value) {
           document.getElementById('hsf-handling-fee-month').textContent = document.getElementById('monthly_handling_fee').value;
            perMonthElRow.querySelector('.handling-fee-info').classList.remove('hidden');
            perMonthElRow.querySelector('.per-month-info').classList.add('hidden');
        }else{
          perMonthElRow.querySelector('.handling-fee-info').classList.add('hidden');
          perMonthElRow.querySelector('.per-month-info').classList.remove('hidden');
        }
        if(document.getElementById('shipment_handling_fee').value) {
            document.getElementById('hsf-handling-fee-shipment').textContent = document.getElementById('shipment_handling_fee').value;
            perShipmentElRow.querySelector('.handling-fee-info').classList.remove('hidden');
            perShipmentElRow.querySelector('.per-shipment-info').classList.add('hidden');  
        }else{
          perShipmentElRow.querySelector('.handling-fee-info').classList.add('hidden');
          perShipmentElRow.querySelector('.per-shipment-info').classList.remove('hidden');
        }

        bundlePriceEl.classList.remove('hidden');

        this.updateChildProductFormVariant()
      } else {
        const { variant: selectedVariant } = this.updateChildProductFormVariant(variant, product);
        variant = selectedVariant;
      }

      return { variant }
    }

    getTaxedPrice(product, variant) {
        let taxPercentage = this.getTaxValue(product, variant);
        let oldPrice = variant.price;
				if (taxPercentage && variant) {
					oldPrice += oldPrice * (taxPercentage / 100);
				}

        return _formatMoney(oldPrice, KROWN.settings.shop_money_format);
		}

    getTaxValue(product, variant) {
      const _variantInfo = JSON.parse(product.querySelector('#variantInfo').innerHTML)
      const selectedVariantInfo = _variantInfo.find(v => v.id == variant.id)
      let taxPercentage = 0;

      if (selectedVariantInfo) {
				taxPercentage = selectedVariantInfo.taxPercentage;
				let taxPercentageOverride = selectedVariantInfo.taxPercentageOverride;
				if (taxPercentageOverride) {
					let taxOverrides = JSON.parse(taxPercentageOverride) || [];
					let currentMarket = selectedVariantInfo.currentMarket;
					for (let override of taxOverrides) {
						if (override.countryCode === currentMarket) {
						taxPercentage = override.tax;
						break;
						}
					}
				}
      }

      return taxPercentage;
    }

    updateChildProductFormVariant(variant) {
      const parentSlot = this.querySelector('.bundler__content').querySelector('[data-js-bundler-product][data-adult-product="true"]');
      const childSlot = this.querySelector('.bundler__content').querySelector('[data-js-bundler-product][data-child-product="true"]');

      if(!childSlot) {
        return { variant };
      }
      const productId = childSlot.dataset.productId;

      const childProduct = this.querySelector('#childSectionProducts').querySelector(`#product-item-${productId}`);

      const id = childProduct
        .querySelector(".product-form")
        .querySelector('input[name="variantId"]').value;

      let childVariant = childProduct
        .querySelector("product-variants")
        .getVariantData()
        .find((v) => {
          return v["id"] == id;
        });

      const hasParentSlot = !!parentSlot

      if(!hasParentSlot) {
        return { variant: childVariant };
      }

      const selectedPaymentTypeContainer = this.querySelector("#data-payment-type-container");
      const selectedPaymentType = selectedPaymentTypeContainer.querySelector("input[type=radio]:checked")?.value;

      const sku = childVariant.sku;
      const isPerShipmentSku = !sku.startsWith('inst_')
      const isInstallmentSku = !isPerShipmentSku
      const productVariantDetails = childProduct.querySelector("product-variants").getVariantData();
      const perShipmentSku = isPerShipmentSku ? sku : sku.slice('inst_'.length, sku.length)
      const perMonthSku = isInstallmentSku ? sku :  "inst_" + sku ;
      const perMonthVariant = productVariantDetails.find((v) => v.sku === perMonthSku);
      const perShipmentVariant = productVariantDetails.find((v) => v.sku === perShipmentSku);

      if (selectedPaymentType == "per_month") {
        childVariant = perMonthVariant;
      } else if(selectedPaymentType == "per_shipment") {
        childVariant = perShipmentVariant;
      } else {
        return { variant: childVariant };
      }

      childProduct.querySelector('input[name="variantId"]').value = childVariant.id;
      childProduct.querySelector('input[name="id"]').value = childVariant.id;
      const variantInfo = this.getVariantInfoData(childProduct);
      this.updateSlotDataset(childSlot, childVariant, variantInfo, childProduct)

      return { variant: childVariant };
    }

    getResizedImageSrc(src, size) {
      if (!src || typeof src !== 'string') {
        return '';
      }

      // Remove any existing size parameters
      const cleanSrc = src.split('?')[0];
      return `${cleanSrc}?width=${size}&height=${size}&crop=center`;
    }

    updateProductDisplayPrice(paymentType) {
      const isMonthlySku = paymentType === 'per_month';
      let productElList = document.querySelectorAll('[id^=product-item-]');

      for(let product of productElList) {
        const productVariantEl = product.querySelector('product-variants');
        productVariantEl.currentVariant = productVariantEl.getVariantData().find((v) => v.sku.startsWith('inst_') === isMonthlySku && v.selling_plan_allocations.length > 0);
        const tax = this.getTaxValue(product, productVariantEl.currentVariant);
        productVariantEl.updatePriceWithTax(tax || 0);
      }
    }

    /**
     * Get selected subscription type
     */
    getSelectedSubscriptionType() {
      const monthlyRadio = this.querySelector('input[name*="type_of_subscription"]:checked');
      if (!monthlyRadio) return null;

      const value = monthlyRadio.value;
      if (value === 'per_month') return 'monthly';
      if (value === 'per_shipment') return 'per_shipment';
      return null;
    }



    /**
     * Get handling fee item for cart based on configuration
     */
    getHandlingFeeItem(adultProductIds, childProductIds) {
      // Check for handling fee configuration
      if (!window.handlingFeeConfig) {
        return null;
      }

      const config = window.handlingFeeConfig;

      // Check if current country is eligible
      if (!this.isCountryEligibleForHandlingFee(config)) {
        return null;
      }

      // Get selected subscription type
      const subscriptionType = this.getSelectedSubscriptionType();
      if (!subscriptionType) {
        return null;
      }
      let variantId = null;
      let sellingPlanId = null;

      // Get the appropriate variant ID based on subscription type
      if(subscriptionType === 'monthly') {
        variantId = config.monthlyVariantId;
        sellingPlanId = document.getElementById('monthly_handling_fee_id').value;
      }else if(subscriptionType === 'per_shipment') {
        variantId = config.yearlyVariantId;
        sellingPlanId = document.getElementById('yearly_handling_fee_id').value;
      }

      if (!variantId) {
        return null;
      }

      // Create simple handling fee item object
      let hfProps = {
        _handling_fee: true,
        _subscriptionType: 'installment',
        _adultProductIds: adultProductIds,
        _childProductIds: childProductIds,
        _hsf: true
      };
      if (typeof window.mergeCartLinePropertiesWithGlobalId === "function") {
        hfProps = window.mergeCartLinePropertiesWithGlobalId(variantId, hfProps);
      }
      return {
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId,
        properties: hfProps
      };
    }


    /**
     * Check if current country is eligible for handling fee
     */
    isCountryEligibleForHandlingFee(config) {
      // If no countries specified, apply to all countries
      if (!config.countries || config.countries.trim() === '') {
        return false;
      }

      // Check if current country is in the allowed list
      const allowedCountries = config.countries.split(',').map(country => country.trim().toUpperCase());
      const currentCountry = Shopify.country ? Shopify.country.toUpperCase() : '';

      return allowedCountries.includes(currentCountry);
    }
  }

  if (typeof customElements.get("hsf-product-bundler") == "undefined") {
    customElements.define("hsf-product-bundler", HSFProductBundler);
  }
}
